﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import HotEditableHelpers_ from "./HotEditableHelpers";
import utilities_ from "../../utilities";

const utilities = require("../../utilities") as typeof utilities_;
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;
// const HotEditableHelpers = require("./HotEditableHelpers") as HotEditableHelpers_;

declare function __getHotEditableHiddenFieldComponentTemplate(): string;

@Component({
    props: {
        initId: String,
        initName: String,
        initValue: String,
    }
})
class HotEditableHiddenFieldComponent extends Vue implements common.IHotEditableFieldComponent {

    initId?: string;
    initName?: string;
    initValue?: string;

    rootId?: string;
    elementValue?: string;
    elementName?: string;
    idElement?: string;
    fieldType = common.HotEditableFieldTypes.hiddenField;

    _previousValue = null as string | null;//NOTE?:  Doit etre NULL (defined) car il est definie dans le "created" (vue)
    _formManager?: HotEditableFormManager_ | null;//NOTE?:  Doit undefined initialement car il est definie dans le "beforeCreate" (vue)
    //_disableNextChangedAction = false;//NOTE?:  Previens le double-changed en provenance du input?: ?: blur()

    static tagName = "hoteditablehiddenfield";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' value=', ' init-value=');

        element.outerHTML = newOuterHtml;
    }

    data() {
        const guid = utilities.createGuid('N');
        const name = this.initName || "Field_" + guid;
        const id = this.initId || name;

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: name,
            elementValue: this.initValue || ''
        };
        return o;
    }

    updatePreviousValue(value?: any) {
        this._previousValue = value || value === '' || value === 0 || value === false ? (value as string).trim() : (this.elementValue || '').trim();
        return this;
    }

    setFromTextualValue(textualValue?: string) {
        textualValue = textualValue || '';

        if (this.elementValue !== textualValue) {
            this.updatePreviousValue();
            this.elementValue = textualValue;
        }

        return this;
    }

    getTextualValue() {
        return this.elementValue || '';
    }

    created() {

    }

    mounted() {
        HotEditableHelpers_.validateFieldSettings(this as any as common.IHotEditableFieldComponent);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this.updatePreviousValue();
    }

    beforeCreate() {
        this._formManager = ((this.$parent as any).formManager as HotEditableFormManager_).registerField(this);
        this.$options.template = __getHotEditableHiddenFieldComponentTemplate();
    }

    clear() {
        this.updatePreviousValue();
        this.elementValue = "";
    }
}

export = HotEditableHiddenFieldComponent;